// extracted by css-extract-rspack-plugin
export default {"logo":"HeaderLogo-module__logo__UFyHI"};